module.exports = __webpack_public_path__ + "media/soundtrack.7c1408c0.mp3";